module.exports = __webpack_public_path__ + "media/images/lane/qr-sign-half-dd6f475a689efe30f9fa834972416c15.svg";